var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "c-checkbox-wrapper custom-control",
      class: {
        "custom-switch": _setup.props.switch,
        "custom-checkbox": !_setup.props.switch,
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _setup.checked,
            expression: "checked",
          },
        ],
        staticClass: "custom-control-input",
        attrs: {
          id: _setup.elementId,
          type: "checkbox",
          disabled: _vm.disabled,
        },
        domProps: {
          checked: Array.isArray(_setup.checked)
            ? _vm._i(_setup.checked, null) > -1
            : _setup.checked,
        },
        on: {
          change: function ($event) {
            var $$a = _setup.checked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_setup.checked = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_setup.checked = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _setup.checked = $$c
            }
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "custom-control-label",
          attrs: { for: _setup.elementId },
        },
        [
          _vm._v("\n        " + _vm._s(_vm.label) + "\n        "),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }